import React, { useState } from 'react';
import { LayoutDashboardIcon, DatabaseIcon, CalendarIcon, ClipboardListIcon, HistoryIcon, PackageIcon, ChevronLeftIcon, ChevronRightIcon, UsersIcon, ArrowUpFromLineIcon } from 'lucide-react';
const navItems = [{
  id: 'dashboard',
  name: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  id: 'products',
  name: 'Produktdatenbank',
  icon: DatabaseIcon
}, {
  id: 'materials',
  name: 'Rohstoff & Rezeptverwaltung',
  icon: PackageIcon
}, {
  id: 'planning',
  name: 'Produktionsplanung',
  icon: CalendarIcon
}, {
  id: 'tracking',
  name: 'Laufzettel-Tracking',
  icon: ClipboardListIcon
}, {
  id: 'traceability',
  name: 'Rückverfolgung',
  icon: HistoryIcon
}, {
  id: 'btrace',
  name: 'B-Trace Export',
  icon: ArrowUpFromLineIcon
}, {
  id: 'users',
  name: 'Benutzerverwaltung',
  icon: UsersIcon
}] as const;
interface NavigationProps {
  activeView: string;
  setActiveView: (view: string) => void;
}
export function Navigation({
  activeView,
  setActiveView
}: NavigationProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return <div className={`${isCollapsed ? 'w-20' : 'w-64'} h-full bg-[#1a181a] text-white flex flex-col relative transition-all duration-300`} data-id="element-371">
      <div className={`p-4 bg-[#ec8301] flex justify-center ${isCollapsed ? 'p-2' : 'p-4'}`} data-id="element-372">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kGoQuUXGG6Rn3UVx45SqYe/logo-kleinemas.png" alt="Kleinemas Logo" className={`${isCollapsed ? 'h-12' : 'h-16'} object-contain transition-all duration-300`} data-id="element-373" />
      </div>
      <button onClick={() => setIsCollapsed(!isCollapsed)} className="absolute -right-3 top-24 bg-[#1a181a] text-white p-1 rounded-full hover:bg-gray-800 transition-colors" data-id="element-374">
        {isCollapsed ? <ChevronRightIcon className="h-4 w-4" data-id="element-375" /> : <ChevronLeftIcon className="h-4 w-4" data-id="element-376" />}
      </button>
      <div className="flex-1 overflow-auto" data-id="element-377">
        <ul className="py-4" data-id="element-378">
          {navItems.map(item => {
          const Icon = item.icon;
          return <li key={item.id} data-id="element-379">
                <button onClick={() => setActiveView(item.id)} className={`w-full flex items-center p-3 text-left transition-colors ${activeView === item.id ? 'bg-[#e20019] text-white' : 'text-gray-300 hover:bg-gray-800'} ${isCollapsed ? 'justify-center' : ''}`} title={isCollapsed ? item.name : undefined} data-id="element-380">
                  <Icon className={`${isCollapsed ? 'mr-0' : 'mr-3'} h-5 w-5`} data-id="element-381" />
                  {!isCollapsed && <span data-id="element-382">{item.name}</span>}
                </button>
              </li>;
        })}
        </ul>
      </div>
      <div className={`p-4 text-center text-sm text-gray-400 border-t border-gray-800 ${isCollapsed ? 'hidden' : 'block'}`} data-id="element-383">
        Kleinemas - Spitzen-Qualität seit 1914
      </div>
    </div>;
}